function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#product-2_svg__filter0_f)"
}, React.createElement("path", {
  d: "M3.922 389.96L521.894 6.845m-.096 17.376L93.338 393.972M7.36 328.63L508.124 6.77",
  stroke: "#D5D4D4",
  strokeWidth: 2
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "product-2_svg__filter0_f",
  x: 0.3,
  y: 0.159,
  width: 525.257,
  height: 399.922,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  result: "effect1_foregroundBlur"
})));

var SvgProduct2 = function SvgProduct2(props) {
  return React.createElement("svg", _extends({
    width: 526,
    height: 401,
    viewBox: "0 0 526 401",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTI2IiBoZWlnaHQ9IjQwMSIgdmlld0JveD0iMCAwIDUyNiA0MDEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXIwX2YpIj4KPHBhdGggZD0iTTMuOTIyMSAzODkuOTZMNTIxLjg5NCA2Ljg0NTA0TTUyMS43OTggMjQuMjIwOUw5My4zMzcyIDM5My45NzJNNy4zNjExMyAzMjguNjNMNTA4LjEyNCA2Ljc2OTA5IiBzdHJva2U9IiNENUQ0RDQiIHN0cm9rZS13aWR0aD0iMiIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2YiIHg9IjAuMjk5ODA1IiB5PSIwLjE1ODY5MSIgd2lkdGg9IjUyNS4yNTciIGhlaWdodD0iMzk5LjkyMiIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJzaGFwZSIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxLjUiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1ciIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgProduct2 as ReactComponent };